import { createContext } from 'react'

import type { UseModalProviderReturn } from './use-modal'

export type ModalContext = Partial<UseModalProviderReturn>

export const ModalContext = createContext<ModalContext>({})
